export default "__VITE_ASSET__tQpx2Ofr__"